
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[organizationSlug]",
      function () {
        return require("private-next-pages/[organizationSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[organizationSlug]"])
      });
    }
  